import { ActionIcon, Indicator, type ActionIconProps } from '@mantine/core'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

/** Hub trophy / lexicon action with a red count badge when `count > 0`. */
export function BoggleHubIndicatorActionIcon({
  children,
  count,
  indicatorSize = 20,
  label,
  ...actionIconProps
}: {
  children: ReactNode
  count: number
  indicatorSize?: number
  label: string
} & ActionIconProps &
  ComponentPropsWithoutRef<'button'>) {
  return (
    <Indicator
      color="red"
      disabled={count <= 0}
      inline
      label={count > 99 ? '99+' : count}
      offset={6}
      position="top-end"
      processing={false}
      size={indicatorSize}
      zIndex={3}
    >
      <ActionIcon aria-label={label} {...actionIconProps}>
        {children}
      </ActionIcon>
    </Indicator>
  )
}
